<template>
  <div id="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <img
        v-if="banner!==undefined"
        class="w-100 h-100"
        :src="`http://www.waternaida.com/${banner}`"
        alt
      />
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/about/mb_about_banner.png" alt />
    </div>
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_item" separator-class="el-icon-arrow-right">
        <span>
          <i class="el-icon-minus"></i> Current position：
        </span>
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>QUIÉNES SOMOS</el-breadcrumb-item>
        <!--<el-breadcrumb-item>News</el-breadcrumb-item>-->
      </el-breadcrumb>
    </div>
    <div class="main w-100">
      <el-tabs class="main_menu" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="BREVE INTRODUCCIÓN" name="first">
          <div class="pane1 wow bounceInUp" data-wow-duration="1s">
            <span class="pane1_head" v-html="company.s_name"></span>
            <span class="pane1_main" v-html="company.s_content"></span>
          </div>
          <div class="pane1-1 wow bounceInUp">
            <span class="pane1_1_txt">Organigrama de la empresa</span>
            <img class="pane1_1_img" src="../../static/img/about/es_main_img.png" alt />
          </div>
          <div class="pane1-2 wow bounceInUp">
            <span class="pane1_2_txt">Revista de Nuesta Fábrica</span>
            <!-- <span class="pane1_2_txt1">Somos fabricantes de purificadores de agua</span> -->
            <div class="pane1-2-img row">
              <viewer :images="images">
                <img
                  class="col-lg-3 col-md-6 col-sm-6 mb-sm-4 mb-xs-1"
                  v-for="(item,index) in images"
                  :src="item"
                  :key="index"
                />
              </viewer>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="NUESTRA FÁBRICA" name="second">
          <div class="pane2 row wow bounceInUp">
            <div
              class="pane2-row col-lg-4 col-md-6 col-sm-6"
              v-for="(item,index) in jihua.slice((currentPage- 1)*pagesize,currentPage*pagesize)"
              :key="index"
            >
              <div class="pane2-item">
                <img class="pane2-img w-100" :src="`http://www.waternaida.com/${item.image}`" alt />
                <span class="pane2-txt">{{item.name}}</span>
              </div>
            </div>
          </div>
          <el-pagination
            class="main_download1_pag"
            background
            layout="prev, pager, next"
            :page-size="pagesize"
            @current-change="current_change"
            :current-page.sync="currentPage"
            :pager-count="5"
            :total="jihua.length"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="CERTIFICADOS" name="third">
          <div class="pane3 wow bounceInUp">
            <viewer class="row" :images="zhengshu">
              <div class="col-lg-4 col-md-6 col-sm-6 third-cl" v-for="(item,index) in zhengshu" :key="index">
                <div class="honor-img">
                    <img class="w-100" :src="`http://www.waternaida.com/${item.image}`" />
                </div>
                <span>{{item.name}}</span>
              </div>
            </viewer>
          </div>
        </el-tab-pane>
        <el-tab-pane label="IMPORTANCIA DE LA CALIDAD" name="fourth">
          <div class="pane4 wow bounceInUp">
            <div class="pane4_main1 row">
              <img class="col-lg-5 col-md-5 col-sm-6" src="../img/about/img4-1.png" alt />
              <div class="col-lg-7 col-md-7 col-sm-6">
                <div>
                  <span>Calidad: un requisito fundamental</span>
                  <span>Adoptar una política de calidad es esencial para la fábrica, ya que está estrechamente relacionado con el rendimiento y también constituye la columna vertebral de nuestra estrategia de desarrollo sostenible.</span>
                </div>
              </div>
            </div>
            <img class="w-100 pane4_main_bj1" src="../img/about/img4-bj-1.png" alt />
            <div class="pane4_main1 pane4_main2 row">
              <div class="col-lg-7 col-md-5 col-sm-6">
                <div>
                  <span>
                    De la producción al servicio: operacional
                    excelencia a través de la calidad
                  </span>
                  <span>
                    Nuestro sistema de gestión de calidad es la piedra angular de nuestra estrategia y una garantía de la fiabilidad, el rendimiento y la durabilidad de nuestros productos. Utilizamos esto como la base de todas nuestras actividades, luchando por la excelencia operativa en todos los niveles.
                    Es por eso que nuestra política de calidad es más que solo producción: concierne a todos y cada uno de los empleados, asegurando que trabajemos juntos para lograr un objetivo común.
                  </span>
                </div>
              </div>
              <img class="col-lg-5 col-md-7 col-sm-6" src="../img/about/img4-2.png" alt />
            </div>
            <img class="w-100" src="../img/about/img4-bj-2.png" alt />
            <div class="pane4_main1 pane4_main2 row">
              <img class="col-lg-5 col-md-5 col-sm-6" src="../img/about/img4-3.png" alt />
              <div class="col-lg-7 col-md-7 col-sm-6">
                <div>
                  <span>Conformidad del producto</span>
                  <span>La calidad de nuestras soluciones es esencial para soportar sistemas complejos y críticos. Combinando durabilidad, calidad técnica y facilidad de instalación, nuestros productos ofrecen total confianza en el rendimiento del sistema. Se ajustan a las normas y estándares más estrictos.</span>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="¿CÓMO CONTROLAR NUESTRA CALIDAD?" name="five">
          <div class="pane5 wow bounceInUp">
            <img class="w-100" src="../img/about/img5-1.png" alt />
            <div class="pane5-txt">
              <span>
                <p class="pane5-txt-all pane5-txt-header">1. OBJETIVO</p>
                <p
                  class="pane5-txt-all"
                >Establecer un procedimiento para garantizar que la compra de material, el proceso de fabricación, los productos terminados y la postventa estén en condiciones controladas.</p>
                <p class="pane5-txt-all pane5-txt-header">2. ALCANCE</p>
                <p
                  class="pane5-txt-all"
                >Elalcance de este procedimiento es el establecimiento de un sistema de control adecuado y eficaz que permita verificar que cumplen los atributos de calidad predefinidos.</p>
                <p class="pane5-txt-all pane5-txt-header">3. RESPONSABILIDADES</p>
                <p
                  class="pane5-txt-all"
                >3.1. El almacén es responsable de la inspección de la compra del material, el proceso subcontratado, el proceso con el material suministrado y los productos terminados salientes.</p>
                <p
                  class="pane5-txt-all"
                >3.2. El taller es responsable de la inspección de los productos terminados almacenados.</p>
                <p
                  class="pane5-txt-all"
                >3.3. El departamento de I + D es responsable de establecer el dibujo SIP y QC.</p>
                <p
                  class="pane5-txt-all"
                >3.4. El departamento de calidad es responsable de ejecutar el dibujo SIP y QC.</p>
                <p
                  class="pane5-txt-all"
                >3.5. El departamento de calidad es responsable de establecer SOP.</p>
                <p
                  class="pane5-txt-all"
                >3.6. El departamento de compras es responsable de deshacerse de la compra de material no calificado, el proceso subcontratado no calificado y el proceso  con el material suministrado no calificado.</p>
                <p
                  class="pane5-txt-all"
                >3.7. El departamento de producción es responsable de inspeccionar la ejecución de la gestión de productos no conformes.</p>
                <p class="pane5-txt-all pane5-txt-header">4. PROCEDIMIENTO</p>
                <el-collapse accordion>
                  <el-collapse-item class="pane5_4 is-active">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.1、 Control de calidad para materia prima y  accesorios</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure_esp1.jpg" alt />
                  </el-collapse-item>
                  <el-collapse-item class="pane5_4">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.2、 Process Quality Control</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure_esp2.jpg" alt />
                  </el-collapse-item>
                  <el-collapse-item class="pane5_4">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.3、 Proceso de almacenamiento de productos terminados</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure_esp3.jpg" alt />
                  </el-collapse-item>
                  <el-collapse-item class="pane5_4">
                    <template slot="title">
                      <img class="mr-3" src="../img/about/椭圆.png" alt />
                      <span class="pane5_4_header">4.4、 Proceso de inspección de nueva muestra del proveedor / muestra de queja de cliente posventa</span>
                    </template>
                    <img class="pane5_4_img w-100 mt-4" src="static/img/about/procudure_esp4.jpg" alt />
                  </el-collapse-item>
                </el-collapse>
                <p class="pane5-txt-all pane5-txt-header">5.Proceso QC de registros relacionados</p>
                <p
                  class="pane5-txt-all"
                >"Nota de entrega", "Pedido de compra", "Registro de inspección entrante", "Lista de acciones preventivas correctivas", "Formulario de revisión de producto no conforme", "Informe de inspección de muestra inicial", "Informe de prueba de muestra", "Registro de inspección"</p>
                <p class="pane5-txt-all pane5-txt-header">6. Nota</p>
              </span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <myfooter class="footer"></myfooter>
  </div>
</template>
<style scoped>
#app {
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
}
.third-cl{
    margin-bottom: 50px;
}
.third-cl span{
    color: #464748;
    margin-top: 25px;
}
.honor-img{
    position: relative;
    margin:0 15%;
    box-shadow:0px 0px 4px 1px rgba(59,59,59,0.11);
}
.pane5_4_img {
  background-color: #f6f6f6;
}
.header-bj {
  margin-top: 40px;
}
.pane5_4_header {
  color: gray;
}
.pane5-txt-all {
  text-align: left;
  color: gray;
}
.pane5-txt-header {
  font-size: 24px;
  color: #0684fa;
}
.pane5 {
  width: 80%;
  margin: 0 auto;
  margin-top: 3%;
}
.pane4_main_bj1 {
  margin-top: -130px;
}

.pane4_main1 {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.pane4_main2 {
  margin-top: -80px;
}
.pane4_main1 > div {
  position: relative;
}
.pane4_main1 > div > div > :first-child {
  text-align: left;
  font-size: 30px;
  margin-bottom: 30px;
}
.pane4_main1 > div > div > :last-child {
  text-align: left;
  font-size: 18px;
}
.pane4_main1 > div > div > span {
  text-align: left;
}
.pane4_main1 > div > div {
  position: absolute;
  top: 50%;
}
.pane3-low {
  margin-top: 18px;
}
.pane3 {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.pane3 > div {
  height: 50%;
}
.pane3-img4 {
  padding-top: 121px;
}
.pane3 > div > img,
span {
  display: block;
  text-align: center;
}
.pane3 > div > span {
  margin-bottom: 50px;
}
.pane3 > div > div:nth-child(5) {
  /*padding-top: 7%;*/
}
.main_download1_pag {
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
}
.pane2-row {
  padding-left: 7px;
  padding-right: 7px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pane2-item-span {
  width: 10px;
}
.pane2-item {
  border: 0px solid #000;
  border-radius: 10px;
  margin-top: 10px;
  text-align: center;
  background-size: cover;
  padding: 0;
  box-shadow: 0px 1px 5px #888888;
}
.pane2-item > img {
  border: 0px solid #000;
  border-radius: 10px 10px 0 0;
}
.pane2 {
  width: 80%;
  margin: 0 auto;
  display: flex;
  margin-top: 50px;
}
.pane2-txt {
  display: none;
  width: 100%;
  font-size: 18px;
  height: 80px;
  line-height: 80px;
}
.pane2-item:hover {
  background-color: #0168b7;
  color: white;
}
.pane2-img {
  display: block;
  width: 100%;
}
.pane1-2-img {
  width: 80%;
  margin: 0 auto;
  margin-top: 120px;
  padding-bottom: 120px;
}
.pane1-2-img > img {
  margin-bottom: 15px;
}
.pane1_1_img {
  width: 80%;
  display: block;
  padding-top: 50px;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 200px;
}
.pane1_2_txt {
  color: black;
  font-size: 40px;
  text-align: center;
  width: 100%;
  display: block;
}
.pane1_2_txt1 {
  color: black;
  font-size: 16px;
  text-align: center;
  width: 100%;
  display: block;
  margin-top: 20px;
}
.pane1_1_txt {
  color: black;
  font-size: 40px;
  text-align: center;
  width: 100%;
  display: block;
  padding-top: 250px;
}
.pane1-2 {
  width: 100%;
  height: 100%;
  background: url("../img/about/main_footer_bj.png");
  text-align: center;
  background-size: cover;
}
.pane1-1 {
  width: 100%;
  height: 100%;
  background: url("../img/about/main_bj.png");
  text-align: center;
  background-size: cover;
  margin-top: 50px;
}
.pane1_main {
  display: block;
  padding-top: 100px;
  width: 80%;
  margin: 0 auto;
  color: #918c8c;
}
.pane1_head {
  display: block;
  font-size: 40px;
  text-align: center;
  color: #1f77ee;
  padding-top: 80px;
}
.pane1 {
  width: 80%;
  height: 100%;
  background: url("../img/about/worldmap.png");
  text-align: center;
  background-size: cover;
  margin: 0 auto;
  margin-top: 80px;
}
.main >>> .el-tabs__header {
  width: 80%;
  margin: 0 auto;
}

.main_menu {
  width: 100%;
  margin: 0 auto;
}
.Breadcrumb {
  /* background: lightblue; */
  display: block;
  width: 80%;
  margin: 0 auto;
  /* float: right; */
  margin-bottom: 100px;
}
.Breadcrumb_item > span {
  float: left;
  display: block;
}
.Breadcrumb_item {
  float: right;
  /* background-color: lightcoral; */
}
@media screen and (max-width: 1200px) {
  .header-bj {
    margin-top: 0px;
  }
}
@media screen and (max-width: 992px) {
  .pane4_main1 > div > div {
    top: 20%;
  }
  .pane4_main1 > div > div > :first-child {
    font-size: 16px;
  }
  .pane4_main1 > div > div > :last-child {
    font-size: 14px;
  }
  .pane4_main1 > div {
    z-index: 999;
  }
}
@media screen and (max-width: 768px) {
  .pane1 {
    width: 90%;
  }
  .Breadcrumb{
    display: inline-block;
    text-align:left;
  }
  .Breadcrumb_item{
    float: left;
  }
  .pane1_main {
    width: 100%;
  }
  .pane1-2-img {
    width: 90%;
  }
  .pane1-2-img > img {
    margin-top: 3%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .pane4_main1 > div > div {
    top: 20%;
  }
}
@media screen and (max-width: 576px) {
  .pane1-2-img > div > img {
    width: 50%;
    margin-top: 3%;
    -webkit-box-flex: 0 !important;
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
  .pane4_main1 > img {
    width: 50%;
    display: none;
  }
  .pane4_main1 > div > div > :first-child {
    font-size: 18px;
  }
  .pane4_main1 > div > div > :last-child {
    font-size: 16px;
  }
  .pane4_main1 > div > div {
    position: relative;
  }
  .pane2 {
    width: 98%;
  }
  .pane4_main1 {
    width: 98%;
  }
  .pane4 {
    height: 100%;
  }
  .pane5-txt-all {
    font-size: 18px;
  }
  .pane1_head {
    font-size: 18px;
    padding-top: 0;
  }
  .pane1_main > span {
    font-size: 16px;
    text-align: left;
  }
  .pane1_1_txt {
    font-size: 18px;
    padding-top: 15%;
  }
  .pane1_2_txt {
    font-size: 18px;
  }
  .pane1_main {
    padding-top: 5%;
  }
  .pane1_1_img {
    padding-top: 5%;
    padding-bottom: 15%;
  }
  .pane1-2-img {
    margin-top: 5%;
    padding-bottom: 5%;
  }
  .pane4_main2 {
    margin-top: 0;
  }
  .pane4_main1 {
    margin-top: 0;
  }
}
</style>
<script>
import myfooter from "./zzj/footer";
import myheader from "./zzj/header_ESP";
import WOW from "wowjs";
export default {
  data() {
    return {
      activeName: "third",
      banner: [],
      images: [
        require("../../static/img/about/img1.png"),
        require("../../static/img/about/img2.png"),
        require("../../static/img/about/img3.png"),
        require("../../static/img/about/img4.png")
      ],
      zhengshu: [],
      jihua: [],
      company: [],
      pagesize: 6, //每页多少数据
      currentPage: 1
    };
  },
  components: {
    myfooter: myfooter,
    myheader: myheader
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    current_change(currentPage) {
      //改变当前页
      this.currentPage = currentPage;
    },
  },
  created() {
    this.axios
      .get("/api/banner/index?categoryID=17&language=1")
      .then(res => {
        this.banner = res.data.imgList[0].image;
        console.log(this.banner);
      })
      .catch(err => {
        console.log(err);
      });

    this.axios
      .get("/api/single/honor?language=2")
      .then(res => {
        this.zhengshu = res.data.honorList;
        console.log(this.zhengshu);
      })
      .catch(err => {
        console.log(err);
      });

    this.axios
      .get("/api/single/plant?language=1")
      .then(res => {
        this.jihua = res.data.plantList;
        console.log(this.jihua);
      })
      .catch(err => {
        console.log(err);
      });

    this.axios
      .get("/api/single/company")
      .then(res => {
        this.company = res.data.companyInfo;
        console.log(this.company);
      })
      .catch(err => {
        console.log(err);
      });
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      mobile: true,
      live: true
    });
    wow.init();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/about_ESP2.vue